import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

//Compoents
import messages from '../../../../locale/messages';
import CompleteOrderPDFForm from './CompleteOrderPDFForm/CompleteOrderPDFForm';

//Action
import { shopCommonModalAction } from '../../../../actions/modalActions';

class CompleteOrderPDFModal extends Component {
    static propTypes = {
        isCompleteBookingPDFModal: PropTypes.bool,
        shopCommonModalAction: PropTypes.func
    }

    render() {
        const { isCompleteBookingPDFModal, shopCommonModalAction } = this.props;

        return (
            <div>
                <Modal show={isCompleteBookingPDFModal} className={'listItemModal'} onHide={() => shopCommonModalAction({ name: "isCompleteBookingPDFModal", value: false })}>
                    <Modal.Header closeButton className='transactionStatementTitle'>
                        <FormattedMessage {...messages.transactionStatement} />
                    </Modal.Header>
                    <Modal.Body>
                        <CompleteOrderPDFForm />
                    </Modal.Body>
                </Modal>
            </div >
        )
    }
};

const mapToState = state => ({
    isCompleteBookingPDFModal: state.modalStatus.isCompleteBookingPDFModal
});

const mapToDispatch = {
    shopCommonModalAction
};

export default injectIntl(connect(mapToState, mapToDispatch)(CompleteOrderPDFModal));